import { useState, useEffect } from 'react'
import { Scrollama, Step } from 'react-scrollama'
import Stage from './Stage'

const ScrollyThree = ({ section, clicked }) => {
  const [currentStepIndex, setCurrentStepIndex] = useState(-1)
  const [direction, setDirection] = useState(null)
  const [fade, setFade] = useState(false)

  const sectionNum = 3
  useEffect(() => {
    if (section <= sectionNum || !section) {
      setFade(false)
    } else setFade(true)

    if (section === sectionNum) setCurrentStepIndex(0)
    else setCurrentStepIndex(-1)
  }, [section, clicked])

  // This callback fires when a Step hits the offset threshold. It receives the
  // data prop of the step, which in this demo stores the index of the step.
  const onStepEnter = ({ data, direction }) => {
    setCurrentStepIndex(data)
    setDirection(direction)
    setFade(false)
  }

  const onStepExit = ({ data, direction }) => {
    if (data === 0 && direction === 'up') setCurrentStepIndex(-1)
    if (data === 1 && direction === 'down') setFade(true)
  }

  const wageContent = [
    'The competition and job-to-job mobility fostered by dynamism helps power wage gains for workers. In a churning labor market where demand for workers is high and competition is intense, workers gain leverage and have ample opportunities to seek out better jobs and higher wages. ',
    'The benefits of a more dynamic labor market have been on clear display during the pandemic, with wage growth for job switchers consistently outpacing that of job stayers by roughly a full percentage point. '
  ]

  return (
    <>
      <div className="scrolly-container">
        <Stage
          currentStepIndex={currentStepIndex}
          direction={direction}
          chart={'wage'}
          fade={fade}
        />
        <div className="scroller">
          <Scrollama
            onStepEnter={onStepEnter}
            onStepExit={onStepExit}
            offset={0.8}
            //debug
          >
            {wageContent.map((item, stepIndex) => (
              <Step data={stepIndex} key={stepIndex}>
                <div className={`step-container ${stepIndex === 1 && 'last'}`}>
                  <div className={`step-content step-${currentStepIndex}`}>
                    {item}
                  </div>
                </div>
              </Step>
            ))}
          </Scrollama>
        </div>
      </div>
    </>
  )
}

export default ScrollyThree
